import Utils from '@/ecm/common/Utils'
export default class ContentTypeExportConfig {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.includeOriginalFile = false
        this.exportMultipleFiles = false
        this.exportFileNamePrefix = ''
        this.exportFileNameSuffix = ''
        this.exportFileNameExtension = 'TXT'
        this.exportToServerLocation = false
        this.exportFilePath = ''
        this.exportEncoding = '65001' // UTF-8
        this.conditionStr = ''
        this.displayConditionStr = ''
        this.exportMask = ''
        this.exportWithHeaders = false;

        if (dto) {
            this.includeOriginalFile = dto.IncludeOriginalFile
            this.exportMultipleFiles = dto.ExportMultipleFiles
            this.exportFileNamePrefix = dto.ExportFileNamePrefix
            this.exportFileNameSuffix = dto.ExportFileNameSuffix
            if (dto.ExportFileNameExtension) {
                this.exportFileNameExtension = dto.ExportFileNameExtension
            }
            if (dto.ExportFilePath) {
                this.exportToServerLocation = true
                this.exportFilePath = dto.ExportFilePath
            }
            this.exportEncoding = dto.ExportEncoding + ''
            this.conditionStr = dto.ConditionStr
            this.exportMask = dto.ExportMask
            this.exportWithHeaders = dto.ExportWithHeaders;
        }
    }

    toDto () {
        return {
            IncludeOriginalFile: this.includeOriginalFile,
            ExportMultipleFiles: this.exportMultipleFiles,
            ExportFileNamePrefix: this.exportFileNamePrefix,
            ExportFileNameSuffix: this.exportFileNameSuffix,
            ExportFileNameExtension: this.exportFileNameExtension,
            ExportFilePath: this.exportToServerLocation ? this.exportFilePath : '',
            ExportEncoding: this.exportEncoding,
            ConditionStr: this.conditionStr,
            ExportMask: this.exportMask,
            ExportWithHeaders: this.exportWithHeaders,
        }
    }
}
